var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FadeTransition',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"duration":200}},[_c('div',{staticClass:"info-bar-modal"},[_c('div',{class:{
        bar_box: true,
        bg_white: _vm.color == 'white',
        bg_black: _vm.color == 'black',
        bg_blue: _vm.color == 'blue',
        bg_red: _vm.color == 'red',
        bg_green: _vm.color == 'green',
        bg_yellow: _vm.color == 'yellow',
      }},[_c('span',{staticClass:"d-block mb-0 mr-2"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"fas fa-times-circle",on:{"click":function($event){return _vm.$emit('close')}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }